<template>
    <v-container fluid pa-0>
        <v-layout row wrap align-center justify-center>
            <v-flex xs3>
                <v-list two-line>
                    <v-list-tile>
                        <v-list-tile-action>
                            <v-icon color="primary">list</v-icon>
                        </v-list-tile-action>
                        <v-list-tile-content>
                            <v-list-tile-title>Saldo</v-list-tile-title>
                            <v-list-tile-sub-title>{{ totalBalance }}</v-list-tile-sub-title>
                        </v-list-tile-content>
                    </v-list-tile>
                </v-list>
            </v-flex>
            <v-flex xs3>
                <v-list two-line>
                    <v-list-tile>
                        <v-list-tile-action>
                            <v-icon color="primary">card_membership</v-icon>
                        </v-list-tile-action>
                        <v-list-tile-content>
                            <v-list-tile-title>Totale Movimenti</v-list-tile-title>
                            <v-list-tile-sub-title>{{ totaleMovements }}</v-list-tile-sub-title>
                        </v-list-tile-content>
                    </v-list-tile>
                </v-list>
            </v-flex>
        </v-layout>
    </v-container>
</template>
<script>
import Vue from 'vue'

export default {
	name: 'resume-footer',
	props: {
		items: Array,
		params: Object,
		info: Object
	},

	data() {
		return {}
	},

	created() {},

	computed: {
		totaleMovements() {
			return this.items ? this.items.length : 0
		},

		totalBalance() {
			return this.items.reduce((acc, item) => {
				if (item.type == 'load') {
					acc += item.amount
				} else {
					acc -= item.amount
				}
				return acc
			}, 0)
		}
	},

	methods: {
		// Call at change select option
	}
}
</script>
